<template>
  <el-dropdown @command="handleCommand">
    <i class="jc-icon icon-listview"></i>
    <el-dropdown-menu slot="dropdown" >
      <el-dropdown-item v-for="(item) in menu"  :key="item.id" :command="item">{{item.value}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    data: Object,
    menu: Array
  },
  methods: {
    handleCommand (item) {
      if (item.action) {
        item.action(this.data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/element/dropdown-menu.vue